import { render, staticRenderFns } from "./BreedsResolvingDialog.vue?vue&type=template&id=97802006"
import script from "./BreedsResolvingDialog.vue?vue&type=script&lang=js"
export * from "./BreedsResolvingDialog.vue?vue&type=script&lang=js"
import style0 from "./BreedsResolvingDialog.vue?vue&type=style&index=0&id=97802006&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports